import * as React from "react";
import ConfigContext from "../../context/ConfigContext";
import { EngagementConfiguration, Message } from "../../types";
import FluidFrame from "../FluidFrame";
import DefaultHead from "../DefaultHead";
import UnreadMessageCount from "./UnreadMessageCount";
import MessagePreviewBox from "../MessagePreview/MessagePreviewBox";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface Props {
  unreadMessages: Array<Message>;
  agentHeadshotUrl: string;
  messagePreviewDisabled: boolean;
  onExpand: () => void;
  onCloseMessagePreview: () => void;
}

class ChattingLauncher extends React.Component<Props & ConfigExtension, {}> {
  renderMessagePreview() {
    if (this.props.messagePreviewDisabled) {
      return;
    }
    return (
      <MessagePreviewBox
        messages={this.props.unreadMessages}
        onExpand={this.props.onExpand}
        onClose={this.props.onCloseMessagePreview}
      />
    );
  }

  getImageUrl() {
    if (this.props.config.ChattingLauncherType === "AgentHeadshot") {
      return this.props.agentHeadshotUrl;
    }

    if (!this.props.config.ChattingLauncherCustomImageUrl) {
      return this.props.agentHeadshotUrl;
    }

    return this.props.config.ChattingLauncherCustomImageUrl;
  }

  public render() {
    return (
      <div className="velaro-launcher-frame velaro-chatting-launcher-frame">
        {this.renderMessagePreview()}
        <UnreadMessageCount
          unreadMessageCount={this.props.unreadMessages.length}
        />
        <FluidFrame head={<DefaultHead />}>
          <div
            className="velaro-chatting-launcher"
            tabIndex={0}
            role="button"
            aria-label="live chat"
            onClick={this.props.onExpand}
            onKeyDown={e => {
              return e.keyCode !== 13 || this.props.onExpand();
            }}
          >
            <img src={this.getImageUrl()} role="presentation" alt="" />
          </div>
        </FluidFrame>
      </div>
    );
  }
}

export default (props: Props) => (
  <ConfigContext.Consumer>
    {config => <ChattingLauncher config={config} {...props} />}
  </ConfigContext.Consumer>
);
